export class Interlocuteur {
  nom: string = '';
  prenom: string = '';
  email: string = '';
  tel: string = '';
}
